import { ThemeProvider } from "@emotion/react";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { QueryClient, QueryClientProvider } from "react-query";
import router from "./Routes/routes";
import { theme } from "./Theme";
import { Box, createTheme } from "@mui/material";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GlobalStyles } from "@mui/system";


function App() {

  const theme = createTheme({
    palette: {
      primary: {
        main: "#9f8054", // Your primary color
      },
      secondary: {
        main: "#7f6540",
      },
    },
    typography: {
      fontFamily: "'Poppins', sans-serif",
    },
  });
  
  const globalStyles = (
    <GlobalStyles
      styles={{
        "::-webkit-scrollbar": {
          width: "6px",
        },
        "::-webkit-scrollbar-track": {
          background: "#f1f1f1",
          borderRadius: "10px",
        },
        "::-webkit-scrollbar-thumb": {
          background: "#bf742c",
          borderRadius: "10px",
          boxShadow: "inset 0 0 10px rgba(0,0,0,0.3)",
        },
        "::-webkit-scrollbar-thumb:hover": {
          background: theme.palette.secondary.main,
        },
      }}
    />
  );


  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <Box className="App">
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          {/* <CssBaseline /> */}
          {globalStyles}
          <RouterProvider router={router} />
        </QueryClientProvider>
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </ThemeProvider>
    </Box>
  );
}

export default App;